import React, { useState, useEffect } from "react";
import worldofmouth from "../../../assets/images/media/word_of_mouth.svg";
import Swal from "sweetalert2";
import api from "../../../api";
import Spinner from "../../LoadingSpinner/loadingSpinner";

const Sponsorship = ({
  sponsorshipPrograms = [],
  sponsorshipCode,
  consumptions,
  referrals = [],
}) => {
  const [languageData, setLanguageData] = useState(null);
  const [loading, setLoading] = useState(false);
  const isNewUser = !referrals || referrals.length === 0;
  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (cookieLang) {
      import(`../../../lang/profile/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.warn("Language cookie 'lang' not found.");
    }
  }, []);
  const formatDuration = (seconds) => {
    if (!seconds && seconds !== 0) return "00:00:00";

    const h = String(Math.floor(seconds / 3600)).padStart(2, "0");
    const m = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
    const s = String(seconds % 60).padStart(2, "0");

    return `${h}:${m}:${s}`;
  };
  const referralUrl = `${process.env.REACT_APP_APPLICATION}/signup?sponsorship=${sponsorshipCode}`;
  const copyReferralLink = async () => {
    try {
      await navigator.clipboard.writeText(referralUrl);

      // Optional success message
      Swal.fire({
        icon: "success",
        title: languageData.alert.share.title,
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Copy failed:", error);
    }
  };
  const getUnitLabel = (unit) => {
    switch (unit) {
      case "period":
        return languageData.tab_sponsorship.call;
      case "volume":
        return "messages";
      default:
        return unit;
    }
  };
  const currencyMap = {
    EUR: "€",
    USD: "$",
    GBP: "£",
  };
  const formatTime = (seconds) => {
    const sec = Number(seconds);

    if (isNaN(sec)) return "00:00:00";

    const hrs = String(Math.floor(sec / 3600)).padStart(2, "0");
    const mins = String(Math.floor((sec % 3600) / 60)).padStart(2, "0");
    const secs = String(sec % 60).padStart(2, "0");

    return `${hrs}:${mins}:${secs}`;
  };
  const takeSponsoredReward = async (reward) => {
    try {
      setLoading(true);
      const response = await api.post(`/services/take-sponsorship-reward`, {
        reward_id: reward.id,
      });
      const responseData = response.data?.data || {};
      const paymentUrl = responseData.payment_url;
      const loyalty_points = responseData.loyalty_points;
      if (
        (reward.type === "discount" || reward.type === "package") &&
        paymentUrl
      ) {
        const width = 800;
        const height = 900;
        const left = window.screenX + (window.outerWidth - width) / 2;
        const top = window.screenY + (window.outerHeight - height) / 2;
        window.open(
          paymentUrl,
          "PaymentWindow",
          `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`,
        );

        return;
      }
      /* if (reward.type === "points") {
        Swal.fire({
          icon: "success",
          text: languageData.tab_sponsorship.free_reward_success,
          confirmButtonText: "OK",
        });
      } */
      // PROGRAM PAYMENT
      if (loyalty_points) {
        await Swal.fire({
          icon: "success",
          title: languageData.alert.success.title,
          html: `
                 <p className="fs-16">${languageData.alert.success.subtitle}</p>
                 <ul className="font-16 flex flex-column align-items-center justify-content-center">
                   ${loyalty_points}
                 </ul>
               `,
          confirmButtonText: "OK",
        });
      } else {
        const result = await Swal.fire({
          icon: "success",
          title: languageData.free_reward_success,
          confirmButtonText: languageData.go_payment,
        });
        if (result.isConfirmed) {
          const width = 800;
          const height = 900;
          const left = window.screenX + (window.outerWidth - width) / 2;
          const top = window.screenY + (window.outerHeight - height) / 2;
          window.open(
            paymentUrl,
            "PaymentWindow",
            `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`,
          );
        }
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: languageData.alert.something_went_wrong.title,
        text:
          error?.response?.data?.message ||
          languageData.alert.something_went_wrong.description,
      });
    } finally {
      setLoading(false);
    }
  };
  const getRuleText = (rule) => {
    const currencyMap = {
      EUR: "€",
      USD: "$",
      GBP: "£",
    };

    if (rule.trigger === "signup") {
      return (
        <>
          <strong>{languageData.tab_sponsorship.signup}</strong>{" "}
          {languageData.tab_sponsorship.signup_sponsorship}
        </>
      );
    }
    if (rule.trigger === "review") {
      return (
        <>
          {languageData.tab_sponsorship.write_reviews}{" "}
          <strong>
            {rule.threshold} {languageData.tab_sponsorship.comments}
          </strong>{" "}
          {rule.time_limit_days != null && (
            <>
              {languageData.tab_sponsorship.within}{" "}
              <strong>{rule.time_limit_days}</strong>{" "}
              {languageData.tab_sponsorship.days}
            </>
          )}
        </>
      );
    }

    if (rule.trigger === "order") {
      if (rule.unit === "total_amount") {
        return (
          <>
            {languageData.tab_sponsorship.spend}{" "}
            <strong>
              {rule.threshold}
              {currencyMap[rule.currency]}{" "}
              {languageData.tab_sponsorship.total_achat}
            </strong>{" "}
            {rule.time_limit_days != null && (
              <>
                {languageData.tab_sponsorship.within}{" "}
                <strong>{rule.time_limit_days}</strong>{" "}
                {languageData.tab_sponsorship.days}
              </>
            )}
          </>
        );
      }

      if (rule.unit === "quantity") {
        return (
          <>
            {languageData.tab_sponsorship.buy}{" "}
            <strong>
              {rule.threshold} {languageData.tab_loyalty.commande}{" "}
            </strong>
            {rule.time_limit_days != null && (
              <>
                {languageData.tab_sponsorship.within}{" "}
                <strong>{rule.time_limit_days}</strong>{" "}
                {languageData.tab_sponsorship.days}
              </>
            )}
          </>
        );
      }
    }

    return "";
  };
  const appName = process.env.REACT_APP_NAME;

  const replaceEnv = (text) => {
    return text.replace(/{{APP_NAME}}/g, appName);
  };
  if (!languageData) {
    return <div></div>;
  }
  return (
    <div
      className="tab-pane fade p-0 border-0 active show"
      id="sponsorship-tab-pane"
      role="tabpanel"
      aria-labelledby="sponsorship-tab"
      tabindex="0"
    >
      <div className="card-body text-center">
        {isNewUser && (
          <div className="ForNewUser">
            <div className="text-center mb-2">
              <span className="avatar avatar-xxxxl">
                <img src={worldofmouth} alt="" />
              </span>
            </div>
            <div className="fs-23 fw-semibold mb-3">
              {languageData.tab_sponsorship.empty}{" "}
            </div>
            <div className="text-muted fs-14 px-4 mb-3">
              {languageData.tab_sponsorship.description}{" "}
            </div>
          </div>
        )}
       {isNewUser && sponsorshipPrograms.length > 0 && (
          <div>
            <button
              type="button"
              className="btn btn-success-gradient btn-wave waves-effect waves-light mb-3"
              data-bs-toggle="collapse"
              data-bs-target="#collapseExample"
              aria-expanded="true"
              aria-controls="collapseExample"
            >
              {languageData.tab_sponsorship.start}
            </button>
          </div>
        )}
        <div
          className={`collapse ${!isNewUser ? "show" : ""}`}
          id="collapseExample"
        >
          <div className="card card-body mb-0">
            <div className="row m-1">
              <div className="border bg-light text-dark p-2 border-top-0">
                <span className=" fs-14 mt-2 text-end">
                  {languageData.tab_sponsorship.how.title}
                </span>
              </div>
              <div className="col-xl-4 text-center p-2 team-performance1 d-flex flex-column align-items-center justify-content-between">
                <div className="me-2 mb-2 mb-sm-0">
                  <span className="avatar avatar-sm br-5 bg-primary-transparent text-primary primary-shadow">
                    <i className="ti ti-mail fs-20"></i>
                  </span>
                </div>
                <div className="flex-grow-1 mt-2">
                  <p className=" fs-16 mt-2 mb-0">
                    <strong>{sponsorshipCode}</strong>{" "}
                  </p>
                  <p className=" fs-16 mt-2 mb-0">
                    {languageData.tab_sponsorship.how.step1}{" "}
                  </p>
                </div>
                <span className="avatar avatar-md avatar-rounded bg-light text-primary shadow-sm mt-2">
                  1
                </span>
              </div>
              <div className="col-xl-4 col-sm-6 col-6 p-0 text-center border border-end-0 p-2 border-start team-performance2 d-flex flex-column align-items-center justify-content-between col-12">
                <div className="me-2 mb-2 mb-sm-0">
                  <span className="avatar avatar-sm br-5 bg-primary-transparent text-primary primary-shadow">
                    <i className="ti ti-edit fs-20"></i>
                  </span>
                </div>
                <div className="flex-grow-1 mt-2 flex flex-column">
                  <span className="fs-16 mb-3">
                    {replaceEnv(languageData.tab_sponsorship.how.step2)}
                  </span>
                </div>
                <span className="avatar avatar-md avatar-rounded bg-light text-primary shadow-sm mt-2">
                  2
                </span>
              </div>
              <div className="col-xl-4 col-sm-6 col-6 text-center border p-2 team-performance3 d-flex flex-column align-items-center justify-content-between col-12">
                <div className="me-2 mb-2 mb-sm-0">
                  <span className="avatar avatar-sm br-5 bg-secondary-transparent text-seconday success-shadow">
                    <i className="ti ti-cash-banknote fs-20"></i>
                  </span>
                </div>
                <div className="flex-grow-1 mt-2 flex flex-column">
                  <span className="fs-16 mb-3">
                    {languageData.tab_sponsorship.discount}
                  </span>
                </div>
                <span className="avatar avatar-md avatar-rounded bg-light text-primary shadow-sm mt-2">
                  3
                </span>
              </div>
            </div>
            {sponsorshipPrograms.map((program) =>
              program.sponsor_rewards?.map((reward) => {
                return (
                  <span className="fs-16 mb-1 d-block mt-1">
                    <span className="d-flex align-items-start flex-column">
                      <div className="mb-1 d-flex flex-wrap gap-4 fs-13 align-items-start flex-column justify-content-between w-100">
                        <div className="flex gap-1 flex-wrap align-items-start flex-column">
                          <h5 className="mb-0 fs-16">
                            {languageData.tab_sponsorship.renumeration}
                          </h5>
                          <div className="flex gap-3 flex-wrap m-10">
                            <div className="card_rewards" key={reward.id}>
                              {reward.type === "discount" && (
                                <div className="badge_rewards">
                                  <>-{parseFloat(reward.discounts?.value)}%</>
                                </div>
                              )}

                              <div className="info">
                                <div className="cat">
                                  {reward.type === "discount"
                                    ? languageData.tab_sponsorship
                                        .discount_title
                                    : reward.type === "points"
                                      ? languageData.tab_loyalty.free_product
                                      : languageData.tab_sponsorship
                                          .package_btn}
                                </div>

                                {reward.packages?.map((pkg) => (
                                  <div key={pkg.id} className="package-block">
                                    <h2 className="title">{pkg.name}</h2>

                                    <p className="desc">
                                      {pkg.items?.map((item) => {
                                        const duration =
                                          item.unit === "period"
                                            ? formatDuration(item.size)
                                            : item.size;

                                        const label =
                                          item.unit === "period"
                                            ? languageData.tab_loyalty.call
                                            : languageData.tab_loyalty.message;

                                        return (
                                          <span
                                            key={item.id}
                                            className="d-block"
                                          >
                                            {duration} {label}
                                          </span>
                                        );
                                      })}
                                    </p>

                                    {pkg.validity &&
                                      !["infinite", "null", ""].includes(
                                        String(pkg.validity).toLowerCase(),
                                      ) && (
                                        <div className="meta">
                                          <span className="rcount">
                                            {languageData.validity}{" "}
                                            {pkg.validity}
                                          </span>
                                        </div>
                                      )}
                                  </div>
                                ))}

  {reward.type === "points" && (
                              
                                 <h2 className="title">{languageData.tab_loyalty.points}</h2>
                              )}
                                <div className="bottom">
                                  <div className="pric">
                                    {reward.type === "discount" && (
                                      <>
                                        <span className="old">
                                          {reward.price}
                                          {currencyMap[reward.currency]}
                                        </span>

                                        <span className="new">
                                          {reward.discounted_price}
                                          {currencyMap[reward.currency]}
                                        </span>
                                      </>
                                    )}

                                    {reward.type === "points" && (
                                      <span className="new">
                                        +{reward.points}{" "}
                                       
                                      </span>
                                    )}
                                  </div>

                                  {reward.available_usage > 0 && (
                                    <button
                                      data-interaction="take_sponsorship_button"
                                      className="btn "
                                      onClick={() =>
                                        takeSponsoredReward(reward)
                                      }
                                    >
                                      {reward.type === "discount"
                                        ? languageData.tab_sponsorship
                                            .discount_btn
                                        : reward.type === "package"
                                          ? languageData.tab_sponsorship
                                              .package_btn
                                          : languageData.tab_sponsorship
                                              .free_btn}
                                    </button>
                                  )}
                                </div>

                                {reward.required_referrals &&
                                  !["infinite", "null", ""].includes(
                                    String(
                                      reward.required_referrals,
                                    ).toLowerCase(),
                                  ) && (
                                    <div className="meta">
                                      <span className="rcount">
                                        <strong>
                                          {reward.required_referrals}
                                        </strong>{" "}
                                        {
                                          languageData.tab_sponsorship
                                            .required_referall
                                        }
                                      </span>
                                    </div>
                                  )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </span>
                  </span>
                );
              }),
            )}
            {/*    {sponsorshipPrograms.map((program) =>
              program.sponsor_rewards?.map((reward) => {
                const price = reward.price;
                const discountedPrice = reward.discounted_price;
                const formattedPrice = Number(discountedPrice || 0).toFixed(2);
                const [wholePart, decimalPart] = formattedPrice.split(".");
                const currency = reward.currency;
                const currencyMap = {
                  EUR: "€",
                  USD: "$",
                  GBP: "£",
                };

                return (
                  <span
                    key={`${program.id}-${reward.id}`}
                    className="fs-16 mb-1 d-block mt-1"
                  >
                    <span className="d-flex align-items-start flex-column">
                      <div className="mb-1 d-flex flex-wrap gap-4 fs-13 align-items-center justify-content-between w-100">
                        <div className="flex gap-1 flex-wrap align-items-start flex-column">
                          <h5 className="mb-0 fs-16">
                            {languageData.tab_sponsorship.renumeration}
                          </h5>
                          <div className="mb-1 d-flex gap-1 fs-13 align-items-center w-100 justify-content-between ">
                            <div className="mb-1 d-flex flex-wrap gap-1 fs-13 align-items-baseline">
                              <i className="bx bxs-circle tx-8 text-primary"></i>
                              {reward.discounts && (
                                <div className="flex align-items-center gap-1 flex-wrap">
                                  <div>
                                    {
                                      languageData.tab_sponsorship
                                        .discount_title
                                    }
                                  </div>
                                  <span className="discount_price">
                                    -{parseFloat(reward.discounts.value)}%
                                  </span>
                                </div>
                              )}

                              {reward.packages?.map((pkg) => (
                                
                                <div className="flex align-items-center gap-1 flex-wrap">
                                  <span>{languageData.tab_loyalty.on_pack}</span>
                                   <span
                                    key={pkg.id}
                                    className="fs-12 d-flex flex-column gap-1 align-items-center fw-500 pack_name"
                                  >
                                  
                                    <span>{pkg.name}</span>
                                      <span key={pkg.id}>
                                    {pkg.items?.map((item, itemIndex) => {
                                      const duration =
                                        item.unit === "period"
                                          ? formatDuration(item.size)
                                          : item.size;

                                      const label =
                                        item.unit === "period"
                                          ? languageData.tab_loyalty.call
                                          : languageData.tab_loyalty.message;
                                      return (
                                        <span key={item.id}>
                                          ({duration} {label})
                                        </span>
                                      );
                                    })}
                                  </span>
                                  </span>
                                  {reward.type === "discount" ? (
                                    <>
                                      <div className="flex align-items-baseline gap-5p">
                                        <strong className="fs-15 green">
                                          {decimalPart ? (
                                            <>
                                              <span className="fs-15">
                                                {wholePart}
                                              </span>
                                              .{decimalPart}
                                            </>
                                          ) : (
                                            discountedPrice
                                          )}
                                          {currencyMap[currency]}
                                        </strong>
                                        <span>{languageData.tab_sponsorship.instead_of}</span>
                                        <span className="discounted_price text-decoration-line-through flex align-items-center">
                                          {price}
                                          {currencyMap[currency]}
                                        </span>
                                      </div>
                                    </>
                                  ) : reward.type === "points" ? (
                              <div className="flex gap-1">
                              <span>{languageData.tab_loyalty.free_product}</span>
                              <strong className="text-success">
                                +{reward.points} points
                              </strong>
                              </div>
                            )  : null}
                                 
                                
                                  {pkg.validity &&
                                    !["infinite", "null", ""].includes(
                                      String(pkg.validity).toLowerCase(),
                                    ) && (
                                      <span className="validity_label">
                                        {languageData.validity} {pkg.validity}
                                      </span>
                                    )}
                                </div>
                              ))}
                              {reward.required_referrals &&
                                !["infinite", "null", ""].includes(
                                  String(
                                    reward.required_referrals,
                                  ).toLowerCase(),
                                ) && (
                                  <span>
                                    (
                                    <strong>{reward.required_referrals}</strong>{" "}
                                    {
                                      languageData.tab_sponsorship
                                        .required_referall
                                    }
                                    )
                                  </span>
                                )}
                            </div>
                            {reward.available_usage > 0 && (
                              <button
                                data-interaction="take_sponsorship_button"
                                className="btn btn-primary btn-sm"
                                onClick={() => takeSponsoredReward(reward)}
                              >
                                {reward.type === "discount"
                                  ? languageData.tab_sponsorship.discount_btn
                                  : reward.type === "package"
                                    ? languageData.tab_sponsorship.package_btn
                                    : reward.type === "points"
                                      ? languageData.tab_sponsorship.free_btn
                                      : ""}
                              </button>
                            )}
                          </div>
                        </div>
                        <div className="flex gap-1 flex-wrap align-items-start flex-column">
                          {program.rules?.length > 0 && (
                            <>
                              <h5 className="mb-0 fs-16">
                                {languageData.tab_sponsorship.title}
                              </h5>
                              <div className="flex gap-2 align-items-center">
                                <div className="flex gap-1 flex-column ">
                                  {program.rules?.map((rule) => (
                                    <span
                                      className="d-flex align-items-center gap-1 rules_sponsor"
                                      key={rule.id}
                                    >
                                       <i class="bx bxs-circle tx-8"></i>
                                      <span className="text-start">
                                        {getRuleText(rule)}
                                      </span>
                                    </span>
                                  ))}
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </span>
                  </span>
                );
              }),
            )} */}
          </div>

          <div className="card custom-card">
            <div className="card-header d-flex align-items-start justify-content-between">
              <div className="flex-1">
                <div className="card-title text-primary">
                  {languageData.tab_sponsorship.share.title}{" "}
                </div>
              </div>
            </div>
            <div className="card-body">
              <p className="mb-3 text-muted text-start">
                {languageData.tab_sponsorship.share.label} :
              </p>
              <div className="form-group">
                <div className="input-group">
                  <input
                    type="text"
                    name="sponsorship_code"
                    className="form-control form-control-lg fw-bold bg-light"
                    placeholder="Account Number"
                    value={`${process.env.REACT_APP_APPLICATION}/signup?sponsorship=${sponsorshipCode}`}
                  />
                  <button
                    data-interaction="copy_sponsorship_url"
                    type="button"
                    className="input-group-text btn btn-primary-light btn-sm lh-lg d-flex justify-content-center"
                    onClick={copyReferralLink}
                  >
                    {languageData.tab_sponsorship.share.copy}
                  </button>
                </div>
              </div>
            </div>
            <div className="card-footer text-start flex flex-column gap-4">
              {sponsorshipPrograms.some(
                (program) => program.sponsored_rewards?.length > 0,
              ) && (
                <h5 className="fs-16 mb-0">
                  {languageData.tab_sponsorship.renumeration_sponsered}
                </h5>
              )}
              <div className="flex gap-3 flex-wrap ">
                {sponsorshipPrograms.map((program) =>
                  program.sponsored_rewards?.map((reward) => {
                    const price = reward.price;
                    const discountedPrice = reward.discounted_price;
                    const formattedPrice = Number(discountedPrice || 0).toFixed(
                      2,
                    );
                    const [wholePart, decimalPart] = formattedPrice.split(".");
                    const currency = reward.currency;

                    const currencyMap = {
                      EUR: "€",
                      USD: "$",
                      GBP: "£",
                    };

                    return (
                      <div
                        key={`${program.id}-${reward.id}`}
                        className="card_rewards"
                      >
                        {reward.type === "discount" && (
                          <div className="badge_rewards">
                            <>-{parseFloat(reward.discounts?.value)}%</>
                          </div>
                        )}

                        <div className="info">
                          <div className="cat">
                            {reward.type === "discount"
                              ? languageData.tab_sponsorship.discount_title
                              : reward.type === "package"
                                ? languageData.tab_sponsorship.package_btn
                                : languageData.tab_loyalty.free_product}
                          </div>

                          {/* Packages */}
                          {reward.packages?.map((pkg) => (
                            <div key={pkg.id} className="package-block">
                              <h2 className="title">{pkg.name}</h2>

                              <p className="desc">
                                {pkg.items?.map((item) => {
                                  const duration =
                                    item.unit === "period"
                                      ? formatDuration(item.size)
                                      : item.size;

                                  const label =
                                    item.unit === "period"
                                      ? languageData.tab_loyalty.call
                                      : languageData.tab_loyalty.message;

                                  return (
                                    <span key={item.id} className="d-block">
                                      {duration} {label}
                                    </span>
                                  );
                                })}
                              </p>

                              {pkg.validity &&
                                !["infinite", "null", ""].includes(
                                  String(pkg.validity).toLowerCase(),
                                ) && (
                                  <div className="meta">
                                    <span className="rcount">
                                      {languageData.validity} {pkg.validity}
                                    </span>
                                  </div>
                                )}
                            </div>
                          ))}

  {reward.type === "points" && (
                              
                                 <h2 className="title">{languageData.tab_loyalty.points}</h2>
                              )}
                          <div className="bottom">
                            <div className="pric">
                              {/* Discount reward */}
                              {reward.type === "discount" && (
                                <>
                                  <span className="old">
                                    {price}
                                    {currencyMap[currency]}
                                  </span>

                                  <span className="new">
                                    {wholePart}.{decimalPart}
                                    {currencyMap[currency]}
                                  </span>
                                </>
                              )}

                              {/* Package reward */}
                              {reward.type === "package" &&
                                reward.packages?.map((pkg) => (
                                  <span className="new" key={pkg.id}>
                                    {pkg.price}
                                    {currencyMap[pkg.currency]}
                                  </span>
                                ))}

                              {/* Points reward */}
                              {reward.type === "points" && (
                              
                                <span className="new">
                                  +{reward.points}
                                  
                                </span>
                              )}
                            </div>

                            {reward.available_usage > 0 && (
                              <button
                                data-interaction="take_sponsorship_button"
                                className="btn"
                                onClick={() => takeSponsoredReward(reward)}
                              >
                                {reward.type === "discount"
                                  ? languageData.tab_sponsorship.discount_btn
                                  : reward.type === "package"
                                    ? languageData.tab_sponsorship.package_btn
                                    : languageData.tab_sponsorship.free_btn}
                              </button>
                            )}
                          </div>

                          {reward.required_referrals &&
                            !["infinite", "null", ""].includes(
                              String(reward.required_referrals).toLowerCase(),
                            ) && (
                              <div className="meta">
                                <span className="rcount">
                                  <strong>{reward.required_referrals}</strong>{" "}
                                  {
                                    languageData.tab_sponsorship
                                      .required_referall
                                  }
                                </span>
                              </div>
                            )}
                        </div>
                      </div>
                    );
                  }),
                )}
              </div>
              {sponsorshipPrograms.map((program) =>
                program.sponsor_rewards?.map((reward) => {
                  return (
                    <div className="flex gap-1 flex-wrap align-items-start flex-column">
                      {program.rules?.length > 0 && (
                        <>
                          <h5 className="mb-0 fs-16">
                            {languageData.tab_sponsorship.title}
                          </h5>
                          <div className="flex gap-2 align-items-center">
                            <div className="flex gap-1 flex-column ">
                              {program.rules?.map((rule) => (
                                <span
                                  className="d-flex align-items-center gap-1 rules_sponsor"
                                  key={rule.id}
                                >
                                  <i class="bx bxs-circle tx-8 fs-11"></i>
                                  <span className="text-start">
                                    {getRuleText(rule)}
                                  </span>
                                </span>
                              ))}
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  );
                }),
              )}
              {/*      {sponsorshipPrograms.map((program) =>
                program.sponsored_rewards?.map((reward) => {
                  const price = reward.price;
                  const discountedPrice = reward.discounted_price;
                  const formattedPrice = Number(discountedPrice || 0).toFixed(
                    2,
                  );
                  const [wholePart, decimalPart] = formattedPrice.split(".");
                  const currency = reward.currency;
                  const currencyMap = {
                    EUR: "€",
                    USD: "$",
                    GBP: "£",
                  };

                  return (
                    <span
                      key={`${program.id}-${reward.id}`}
                      className="fs-16 mb-1 d-block mt-1"
                    >
                      <span className="d-flex align-items-start flex-column">
                        <div className="mb-1 d-flex flex-wrap gap-1 fs-13 align-items-center justify-content-between w-100">
                          <div className="mb-1 d-flex flex-wrap gap-1 fs-13 align-items-center">
                            <i className="bx bxs-circle tx-8 text-primary"></i>

                            {reward.discounts && (
                              <div className="flex align-items-center gap-1 flex-wrap">
                                <div>
                                  {languageData.tab_sponsorship.discount_title}
                                </div>
                                <span className="discount_price">
                                  -{parseFloat(reward.discounts.value)}%
                                </span>
                              </div>
                            )}
                            {reward.packages?.map((pkg) => (
                              <div className="flex align-items-center gap-1 flex-wrap">
                                <span
                                  key={pkg.id}
                                  className="fs-13 d-flex flex-column gap-1 align-items-center fw-500 sponsered_pack"
                                >
                                  <span> {pkg.name}</span>
                                  <span key={pkg.id}>
                                    {pkg.items?.map((item, itemIndex) => {
                                      const duration =
                                        item.unit === "period"
                                          ? formatDuration(item.size)
                                          : item.size;

                                      const label =
                                        item.unit === "period"
                                          ? languageData.tab_loyalty.call
                                          : languageData.tab_loyalty.message;
                                      return (
                                        <span key={item.id}>
                                          ({duration} {label})
                                        </span>
                                      );
                                    })}
                                  </span>
                                </span>

                                {pkg.validity &&
                                  !["infinite", "null", ""].includes(
                                    String(pkg.validity).toLowerCase(),
                                  ) && (
                                    <span className="validity_label">
                                      {languageData.validity} {pkg.validity}
                                    </span>
                                  )}
                              </div>
                            ))}
                            {reward.type === "discount" ? (
                              <>
                                <strong className="fs-15 green">
                                  <span className="fs-15">{wholePart}</span>.
                                  {decimalPart}
                                  {currencyMap[currency]}
                                </strong>
                                <span>
                                  {languageData.tab_sponsorship.instead_of}
                                </span>
                                <span className="discounted_price text-decoration-line-through">
                                  {price}
                                  {currencyMap[currency]}
                                </span>
                              </>
                            ) : reward.type === "points" ? (
                              <div className="flex gap-1">
                                <span>
                                  {languageData.tab_loyalty.free_product}
                                </span>
                                <strong className="text-success">
                                  +{reward.points} points
                                </strong>
                              </div>
                            ) : null}

                            {reward.required_referrals &&
                              !["infinite", "null", ""].includes(
                                String(reward.required_referrals).toLowerCase(),
                              ) && (
                                <span>
                                  (<strong>{reward.required_referrals}</strong>{" "}
                                  {
                                    languageData.tab_sponsorship
                                      .required_referall
                                  }
                                  )
                                </span>
                              )}
                          </div>
                          {reward.available_usage > 0 && (
                            <button
                              data-interaction="take_sponsorship_button"
                              className="btn btn-primary btn-sm"
                              onClick={() => takeSponsoredReward(reward)}
                            >
                              {reward.type === "discount"
                                ? languageData.tab_sponsorship.discount_btn
                                : reward.type === "package"
                                  ? languageData.tab_sponsorship.package_btn
                                  : reward.type === "points"
                                    ? languageData.tab_sponsorship.free_btn
                                    : ""}
                            </button>
                          )}
                        </div>
                      </span>
                    </span>
                  );
                }),
              )} */}
            </div>
          </div>
          <div className="card custom-card">
            <table id="datatable-basic" className="table table-bordered w-100">
              <thead>
                <tr>
                  <th scope="col">
                    {languageData.tab_sponsorship.table.receiver}{" "}
                  </th>
                  <th scope="col">
                    {languageData.tab_sponsorship.table.date_insc}{" "}
                  </th>
                  <th scope="col">
                    {languageData.tab_sponsorship.table.date_sent}
                  </th>

                  <th scope="col">
                    {languageData.tab_sponsorship.table.amount}{" "}
                  </th>
                </tr>
              </thead>
              <tbody>
                {referrals.length > 0 ? (
                  referrals.map((item, index) => (
                    <tr key={index}>
                      <td>
                        {item.first_name} {item.last_name}
                      </td>
                      <td>{item.created_at}</td>
                      <td>{item.first_transaction}</td>

                      <td>{item.points}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center">
                      {languageData.tab_sponsorship.table.no_referrals}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {loading && (
        <div className="spinner-overlay">
          <Spinner />
        </div>
      )}
    </div>
  );
};

export default Sponsorship;
